/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MoneyAmountWithOptionalTaxFromJSON, MoneyAmountWithOptionalTaxToJSON, } from './MoneyAmountWithOptionalTax';
import { SellerProductReferenceFromJSON, SellerProductReferenceToJSON, } from './SellerProductReference';
/**
 * Check if a given object implements the RentalOverviewRequest interface.
 */
export function instanceOfRentalOverviewRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "sellerProductReference" in value;
    return isInstance;
}
export function RentalOverviewRequestFromJSON(json) {
    return RentalOverviewRequestFromJSONTyped(json, false);
}
export function RentalOverviewRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'baseRentalPrice': !exists(json, 'base_rental_price') ? undefined : MoneyAmountWithOptionalTaxFromJSON(json['base_rental_price']),
        'price': !exists(json, 'price') ? undefined : MoneyAmountWithOptionalTaxFromJSON(json['price']),
        'quantity': json['quantity'],
        'sellerProductReference': SellerProductReferenceFromJSON(json['seller_product_reference']),
    };
}
export function RentalOverviewRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'base_rental_price': MoneyAmountWithOptionalTaxToJSON(value.baseRentalPrice),
        'price': MoneyAmountWithOptionalTaxToJSON(value.price),
        'quantity': value.quantity,
        'seller_product_reference': SellerProductReferenceToJSON(value.sellerProductReference),
    };
}
